export default __webpack_public_path__ + "static/media/sample-coordinates.bea7bcbb.txt";